import React, { ReactNode } from 'react';
import { AdminConfigConfiguration, AdminConfigMicroserviceConfigurationProvider } from '@centecomm/portal-service-react';

type AdminConfigProviderConfigProps = {
    children: ReactNode;
    token: string;
};

const AdminConfigProviderConfig: React.FC<AdminConfigProviderConfigProps> = ({
    children,
    token,
}: AdminConfigProviderConfigProps) => {
    const serviceConfig = React.useMemo<AdminConfigConfiguration>(
        () => ({
            apiRoot: ADMIN_CONFIG_API_ROOT || '',
            options: {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        }),
        [token],
    );

    return (
        <AdminConfigMicroserviceConfigurationProvider configuration={serviceConfig}>
            {children}
        </AdminConfigMicroserviceConfigurationProvider>
    );
};

export default AdminConfigProviderConfig;
